import { createContext } from 'react'

const TrailStepContext = createContext()

export default TrailStepContext
